module.exports = __webpack_public_path__ + "img/162013.e7da8a0e.jpg";